export enum LoggerNbiotStatus {
  Deployed = 'DEPLOYED',
  EmptyMeasurement = 'EMPTY_MEASUREMENT',
  FullMeasurement = 'FULL_MEASUREMENT',
  MissingHistogramAndSignal = 'MISSING_HISTOGRAM_AND_SIGNAL',
  MissingSignal = 'MISSING_SIGNAL',
  NoMeasurement = 'NO_MEASUREMENT',
  Registered = 'REGISTERED',
}
